import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { Shield } from "lucide-react";
import { API } from "@/lib/api";

export function useBranding() {
  return useQuery({
    queryKey: ["branding"],
    queryFn: async () => (await axios.get(`${API}/branding`)).data,
    staleTime: 60000,
  });
}

export const logoUrl = (b) => `${API}/branding/logo?v=${encodeURIComponent(b?.updated_at || "")}`;

export const BrandMark = ({ className = "bg-[#B84A2B] text-white" }) => {
  const { data } = useBranding();
  if (data?.has_logo) {
    return <img src={logoUrl(data)} alt="GoWeb" className="w-8 h-8 rounded-lg object-contain bg-white" data-testid="brand-logo" />;
  }
  return (
    <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${className}`} data-testid="brand-mark">
      <Shield size={16} />
    </div>
  );
};

export const FaviconSync = () => {
  const { data } = useBranding();
  const hasLogo = !!data?.has_logo;
  const version = data?.updated_at || "";
  useEffect(() => {
    const href = hasLogo ? `${API}/branding/logo?v=${encodeURIComponent(version)}` : "/favicon.svg";
    const type = hasLogo ? "image/png" : "image/svg+xml";
    document.querySelectorAll("link[rel='icon'], link[rel='apple-touch-icon']").forEach((l) => {
      l.setAttribute("href", href);
      if (l.rel === "icon") l.setAttribute("type", type);
    });
  }, [hasLogo, version]);
  return null;
};
